export default "__VITE_ASSET__AsCWxihM__"